export const primaryBlack = '#282828';
export const primaryGreen = '#52b36b';
export const lightGreen = '#5cb082';
export const primaryOrange = '#EF8031';
export const primaryRed = '#ED5050';
export const brightRed = '#d01e1e';
export const primaryGrey = '#AFB8CA';
export const primaryDarkGrey = '#7a89a7';
export const primaryLightGrey = '#eff2f7';
export const primaryBlue = '#2B39B9';
export const primaryWhite = '#FFFFFF';
export const neutral = '#E4E7ED';
